import facebookService from '@/lib/services/facebook';
import { isFacebookLogin } from '@/lib/utils/loginFlow';

/**
 * The FB JS SDK is only consumed by getProfileImageUrl during the Facebook
 * login callback (#access_token hash). Loading it on idle for every shop
 * visit cost ~80KB transfer / ~260KB parse of third-party JS (Lighthouse
 * TBT). Everywhere else the SDK is dead weight — the login button itself
 * uses a redirect, not the SDK.
 */
export function initFacebookSdkForLoginCallback(fbAppId: string): boolean {
    if (!isFacebookLogin()) {
        return false;
    }
    facebookService.initialize(fbAppId).catch(() => undefined);
    return true;
}
